import Membership from '../../models/membership';

export enum OptionItem {
  Edit = 'Edit',
  Duplicate = 'Duplicate',
  Rename = 'Rename',
  Delete = 'Delete',
  Regenerate = 'Regenerate',
  Test = 'Test',
  // section 2
  Export = 'Export Data',
  Import = 'Import Data',
  // section 3
  Activity = 'Activity',
  Workflows = 'Workflows',
  Reports = 'Reports',
  // section 4
  Shared = 'Shared Views',
  Repeatables = 'Repeatables',
  // section 5
  Deactivate = 'Deactivate',
}

export enum Resource {
  Form = 'form',
  Layer = 'layer',
  Project = 'project',
  Group = 'group',
  Record = 'record',
  Field = 'field'
}

export interface CardGridItemProps {
  readonly id: string;
  readonly primaryText: string;
  readonly actionItems: OptionItem[];
  readonly contextResources: Partial<Record<Resource, number>>;
  readonly onActionItemClick: (action: OptionItem, id: string) => void;
  readonly secondaryText?: string;
  readonly tag?: string;
  readonly avatarSrc?: string;
  readonly memberResources?: Membership[];
}

export type EventData = {
  id: string,
  title?: string,
  subtitle?: string,
  primaryText?: string,
  secondaryText?: string,
  description?: string,
  avatarSrc?: string
}
